import { Box, Button, Stack, Typography } from '@mui/material';
import { useRefundRequestNavigation } from '@/packages/subsidy/pages/refund-request/steps/resource-description/navigation/use-navigation';
import { RefundRequestWizardStepIds } from '@/packages/subsidy/pages/refund-request/steps/resource-description/steps/step-ids';
import { getSvg } from '@/utils/get-svg';

const stepId = RefundRequestWizardStepIds.Summary;

export const Reproved = () => {
  const { handleBack } = useRefundRequestNavigation({ stepId });

  return (
    <Box>
      <Box
        component="img"
        src={getSvg('resource_without_eligibility.svg')}
        sx={{ width: 128, marginBottom: 3 }}
      />
      <Typography variant="h3" color="primary.900" sx={{ marginBottom: 1 }}>
        Reembolso indisponível
      </Typography>
      <Typography>
        O item que você solicitou não é contemplado pelas suas políticas, revise
        o item solicitado e suas políticas para garantir que o item possa ser
        reembolsado.
      </Typography>
      <Stack direction="row" justifyContent="flex-end">
        <Button variant="contained" onClick={handleBack}>
          Voltar
        </Button>
      </Stack>
    </Box>
  );
};
